/** The Sign-in screen's query keys: shared with the directory screen and the removal dialog. */
export const signinKeys = { identityProviders: ["admin", "identity-providers"] as const };
